module.exports = __webpack_public_path__ + "img/icon-chef-hat.a58ddaea.svg";